// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"316":"ad2866b8","501":"bc98253f","930":"164f4fb6"}[chunkId] || chunkId) + "." + {"7":"7c3e20994b1f7af7","316":"83f2bbcd93d01219","501":"d13bf505216111a2","756":"9257bdd13cafb3a4","839":"6a81f53822d98751","930":"09e786546f77df07"}[chunkId] + ".js";
};